import { tablePaginationClasses } from '@mui/material';

export const muiTablePaginationOverrides = {
	styleOverrides: {
		root: () => {
			return {
				[`.${tablePaginationClasses.displayedRows}`]: {
					margin: 0,
				},
			};
		},
	},
};
